module.exports = __webpack_public_path__ + "static/media/trash.19cff6fa.svg";